import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { useAuth } from "../context/AuthContext";
import MainNavbar from "../pages/MainNavbar";
import Footer from "./footers";
import Breadcrumbs from "./Breadcrumbs";
import "./Rewards.css";
import { GET_REWARD_DETAILS } from "../graphql/userQuery";

const Rewards: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const [showSubnav, setShowSubnav] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const userId = currentUser?.id || "";
  const isLoggedIn = !!currentUser;

  // ==========================================
  // GET REWARD DETAILS
  // ==========================================

  const {
    data,
    loading: rewardLoading,
    error: rewardError,
  } = useQuery(GET_REWARD_DETAILS, {
    variables: {
      userId,
    },
    skip: !userId,
    fetchPolicy: "network-only",
  });

  // ==========================================
  // REWARD VALUES
  // ==========================================

  const rewardDetails = data?.getRewardDetails;
console.log("Reward Details:", rewardDetails);  
  const rewardBalance = Number(
    rewardDetails?.walletBalance || 0
  );

  const rewardsUsed = Number(
    rewardDetails?.totalUsed || 0
  );

  const totalEarned = Number(
    rewardDetails?.totalEarned || 0
  );

  // ==========================================
  // REFERRAL LINK
  // ==========================================

  const referralLink = userId
    ? `https://lngmart.in/login?ref=${userId}`
    : "";

  // ==========================================
  // REFERRAL MODAL
  // ==========================================

  const handleOpenReferralModal = () => {
    setCopied(false);
    setShowReferralModal(true);
  };

  const handleCloseReferralModal = () => {
    setShowReferralModal(false);
    setCopied(false);
  };

  const handleCopyReferralLink = async () => {
    if (!referralLink) return;

    try {
      await navigator.clipboard.writeText(referralLink);

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);

    } catch (error) {
      console.error(
        "Failed to copy referral link:",
        error
      );
    }
  };

  const handleShareReferralLink = async () => {
    if (!referralLink) return;

    const shareData = {
      title: "Join LNG Mart",
      text: "Join LNG Mart using my referral link!",
      url: referralLink,
    };

    try {

      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await handleCopyReferralLink();
      }

    } catch (error) {
      console.error(
        "Share cancelled or failed:",
        error
      );
    }
  };

  // ==========================================
  // LOADING
  // ==========================================

  if (rewardLoading && userId) {
    return (
      <div className="rewards-page-wrapper">

        <MainNavbar
          searchQuery=""
          setSearchQuery={() => {}}
          isLoggedIn={isLoggedIn}
          showSubnav={showSubnav}
          setShowSubnav={setShowSubnav}
          userId={userId}
          disableSearch={true}
        />

        <Breadcrumbs />

        <div className="rewards-container">

          <div className="rewards-header">
            <h2>My Rewards</h2>
          </div>

          <div className="reward-wallet-card">

            <div className="reward-wallet-left">

              <div className="reward-icon-wrapper">
                <span className="reward-icon">
                  🎁
                </span>
              </div>

              <div className="reward-wallet-info">

                <span className="wallet-label">
                  Reward Wallet Balance
                </span>

                <h1>
                  Loading...
                </h1>

              </div>

            </div>

          </div>

        </div>

        <Footer />

      </div>
    );
  }

  return (
    <div className="rewards-page-wrapper">

      {/* Navbar */}
      <MainNavbar
        searchQuery=""
        setSearchQuery={() => {}}
        isLoggedIn={isLoggedIn}
        showSubnav={showSubnav}
        setShowSubnav={setShowSubnav}
        userId={userId}
        disableSearch={true}
      />

      {/* Breadcrumb */}
      <Breadcrumbs />

      {/* Main Content */}
      <div className="rewards-container">

        {/* Page Header */}
        <div className="rewards-header">

          <div>

            <h2>
              My Rewards
            </h2>

          </div>

        </div>

        {/* API Error */}
        {rewardError && (

          <div className="reward-error-message">

            Unable to load reward details.

          </div>

        )}

        {/* Main Wallet Card */}
        <div className="reward-wallet-card">

          {/* Left - Reward Balance */}
          <div className="reward-wallet-left">

            <div className="reward-icon-wrapper">

              <span className="reward-icon">
                🎁
              </span>

            </div>

            <div className="reward-wallet-info">

              <span className="wallet-label">
                Reward Wallet Balance
              </span>

              <h1>
                ₹{rewardBalance.toFixed(2)}
              </h1>

              <p>
                Available reward balance
              </p>

            </div>

          </div>

          {/* Right - Rewards Used */}
          <div className="reward-wallet-right">

            <div className="reward-wallet-used-label">
              Rewards Used
            </div>

            <div className="reward-points-value">
              ₹{rewardsUsed.toFixed(2)}
            </div>

            <p className="reward-used-description">
              Total rewards used
            </p>

          </div>

        </div>

        

        {/* Referral CTA */}
        <div className="reward-referral-card">

          <div className="reward-referral-content">

            <div className="reward-referral-icon">
              👥
            </div>

            <div>

              <h3>
                Refer a Friend
              </h3>

            </div>

          </div>

          <button
            className="reward-refer-btn"
            onClick={handleOpenReferralModal}
            disabled={!userId}
          >
            Refer a Friend
          </button>

        </div>

        {/* How Rewards Work */}
        <div className="rewards-section">

          <div className="rewards-section-header">

            <h3>
              How Rewards Work
            </h3>

          </div>

          <div className="reward-info-grid">

            {/* Step 1 */}
            <div className="reward-info-card">

              <div className="reward-step-number">
                1
              </div>

              <div>

                <h4>
                  Purchase a Reward Product
                </h4>

                <p>
                  Purchase an eligible reward product and earn
                  rewards that are added to your reward wallet.
                </p>

              </div>

            </div>

            {/* Step 2 */}
            <div className="reward-info-card">

              <div className="reward-step-number">
                2
              </div>

              <div>

                <h4>
                  Earn Rewards
                </h4>

                <p>
                  Your earned rewards are added to your reward
                  wallet and can be viewed here.
                </p>

              </div>

            </div>

            {/* Step 3 */}
            <div className="reward-info-card">

              <div className="reward-step-number">
                3
              </div>

              <div>

                <h4>
                  Refer a Friend
                </h4>

                <p>
                  To use your earned rewards, refer a friend
                  using your personal referral link.
                </p>

              </div>

            </div>

            {/* Step 4 */}
            <div className="reward-info-card">

              <div className="reward-step-number">
                4
              </div>

              <div>

                <h4>
                  Friend Purchases a Reward Product
                </h4>

                <p>
                  Your referred friend must purchase a
                  qualifying reward product.
                </p>

              </div>

            </div>

            {/* Step 5 */}
            <div className="reward-info-card">

              <div className="reward-step-number">
                5
              </div>

              <div>

                <h4>
                  Rewards Unlocked
                </h4>

                <p>
                  Once the referral condition is completed,
                  your earned rewards become available for use.
                </p>

              </div>

            </div>

            {/* Step 6 */}
            <div className="reward-info-card">

              <div className="reward-step-number">
                6
              </div>

              <div>

                <h4>
                  Use Your Rewards
                </h4>

                <p>
                  Use your unlocked reward balance for eligible
                  purchases.
                </p>

              </div>

            </div>

          </div>

        </div>

        {/* Reward Usage */}
        <div className="reward-usage-section">

          <div className="reward-usage-icon">
            🛍️
          </div>

          <div className="reward-usage-content">

            <h3>
              Use Your Rewards
            </h3>

            <p>
              Once your rewards are unlocked, you can use your
              reward balance for eligible purchases.
            </p>

          </div>

          <button
            className="reward-shop-btn"
            onClick={() => navigate("/")}
          >
            Start Shopping
          </button>

        </div>

      </div>

      {/* ==========================================
          REFERRAL MODAL
      ========================================== */}

      {showReferralModal && (

        <div
          className="reward-modal-overlay"
          onClick={handleCloseReferralModal}
        >

          <div
            className="reward-modal"
            onClick={(event) => event.stopPropagation()}
          >

            {/* Modal Header */}
            <div className="reward-modal-header">

              <div>

                <h3>
                  Refer a Friend
                </h3>

                <p>
                  Share your referral link with your friend.
                </p>

              </div>

              <button
                className="reward-modal-close"
                onClick={handleCloseReferralModal}
                aria-label="Close"
              >
                ×
              </button>

            </div>

            {/* Modal Body */}
            <div className="reward-modal-body">

              <div className="reward-modal-icon">
                👥
              </div>

              <h4>
                Invite Your Friend
              </h4>

              <p>
                Share this link with your friend. When they
                sign up and purchase a qualifying reward
                product, your rewards can become unlocked.
              </p>

              {/* Referral Link */}
              <div className="referral-link-container">

                <input
                  type="text"
                  value={referralLink}
                  readOnly
                  onFocus={(event) => event.target.select()}
                />

                <button
                  className="referral-copy-btn"
                  onClick={handleCopyReferralLink}
                >
                  {copied ? "Copied!" : "Copy"}
                </button>

              </div>

              {/* Share */}
              <button
                className="referral-share-btn"
                onClick={handleShareReferralLink}
              >
                Share Referral Link
              </button>

            </div>

          </div>

        </div>

      )}

      {/* Footer */}
      <Footer />

    </div>
  );
};

export default Rewards;
